import {
  Footer,
  Navigation
} from '@/ui/design-system'
import { PageLayout } from '@/ui/layout'
import { Logo } from '@/ui/components'
import { Landing3DHero } from '@/ui/components/landing/hero/Landing3DHero'
import { ProblemStatement } from '@/ui/components/landing/sections/ProblemStatement'
import { CollaborationSpotlight } from '@/ui/components/landing/sections/CollaborationSpotlight'
import { FeatureSections } from '@/ui/components/landing/sections/FeatureSections'
import { MobileAppSection } from '@/ui/components/landing/sections/MobileAppSection'
import { FinalCTA } from '@/ui/components/landing/sections/FinalCTA'
import { Pricing } from '@/ui/components/landing/pricing-section-with-comparison'

export default function LandingPage() {
  // Navigation configuration
  const navigationItems = [
    {
      title: "Home",
      href: "/",
    },
    {
      title: "About",
      href: "/about",
    },
  ]

  const navigationActions = {
    primary: { label: "Get started", href: "/signup" },
    secondary: { label: "Sign in", href: "/login" }
  }

  // Footer configuration
  const footerSections = [
    {
      title: "Product",
      links: [
        { label: "About Us", href: "/about" },
        { label: "Sign Up", href: "/signup" },
      ]
    },
    {
      title: "Support",
      links: [
        { label: "Documentation", href: "/docs" },
        { label: "Contact Us", href: "/contact" },
        { label: "Report Issue", href: "/contact" },
      ]
    },
    {
      title: "Legal",
      links: [
        { label: "Terms of Service", href: "/terms" },
        { label: "Privacy Policy", href: "/privacy" },
      ]
    }
  ]

  return (
    <PageLayout showHeader={false}>
      {/* Navigation */}
      <Navigation
        logo={
          <div className="flex items-center gap-2">
            <Logo to="/" size="md" />
            <span className="text-lg font-semibold text-foreground">
              SitRepp.io
            </span>
          </div>
        }
        items={navigationItems}
        actions={navigationActions}
      />

      {/* 3D terrain hero */}
      <Landing3DHero />

      {/* Why group chats fail */}
      <ProblemStatement />

      {/* Collaboration — the differentiator */}
      <CollaborationSpotlight />

      {/* Feature walkthrough */}
      <FeatureSections />

      {/* Mobile app coming soon */}
      <MobileAppSection />

      {/* Pricing */}
      <Pricing />

      {/* Final CTA */}
      <FinalCTA />

      {/* Footer */}
      <Footer
        sections={footerSections}
        description="Built for crews who do not want every open invite to include map pins and full route geometry. Share links with per-link permissions: hide coordinates until you trust someone, then align on itinerary, gear, discovery, and weather in one place."
      />
    </PageLayout>
  )
}
